export default __webpack_public_path__ + "static/media/dollar-red.80de5aed.svg";